import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-loading-dialog',
    templateUrl: './loading-dialog.component.html',
    standalone: false
})
export class LoadingDialogComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
